<div [hidden]="!data" (click)="$event.stopImmediatePropagation()">
  <form [hidden]="!showHeaders || !!data?.hideHeaders">
    <div *ngIf="hasCheckboxes"></div>
    <div *ngFor="let header of data?.headers; index as i;" [class]="header.flex">
      <p [title]="header.label">{{header.label}}
        <span [hidden]="!header.legend" [class]="'lib-legend ' + header.legend?.class || ''"
          [title]="header.legend?.value">{{header.legend?.value}}</span>
      </p>
      <div [class.active]="sort === i" [hidden]="!header.sortable"
        (click)="emitEvent($event, 'sort',  { data: header.data, index: i })">
        <lib-icon name="chevronUp"></lib-icon>
        <lib-icon name="chevronDown"></lib-icon>
      </div>
    </div>
    <div class="options"></div>
  </form>
  <ul>
    <li *ngFor="let row of data?.rows; index as i;" class="lib-elevation-1" [class.event]="!!row.event"
      (click)="emitEvent($event, row.event, row.data)" [ngClass]="row.class || ''" [attr.data-test]="testAttribute">
      <div>
        <div *ngIf="row?.checkbox">
          <lib-checkbox [checked]="checkboxes[row.data]"></lib-checkbox>
        </div>
        <div *ngFor="let column of row.columns; index as n;" [class]="getFlex(n)" [ngSwitch]="!!column.event">
          <!-- <lib-icon *ngIf="!!column.value.icon" name="column.value.icon"></lib-icon> -->
          <div>
            <p *ngSwitchCase="false" [title]="column.value">{{column.value}}</p>
            <button type="button" class="lib-button-flat" *ngSwitchCase="true" [title]="column.value"
              (click)="emitEvent($event, column.event, column.data)">
              <span *ngIf="!!column.value">{{column.value}}</span>
            </button>
            <p [hidden]="!column.legend" [class]="'lib-legend ' + column.legend?.class || ''"
              [title]="column.legend?.value">{{column.legend?.value}}</p>
          </div>
        </div>
        <div class="options">
          <button type="button" class="lib-button-flat" [hidden]="!row.options?.length">
            <lib-icon name="options"></lib-icon>
          </button>
          <ul class="lib-elevation-1" [hidden]="!row.options?.length">
            <li *ngFor="let option of row.options; index as j;">
              <button [class]="option.class || 'lib-button'" type="button"
                (click)="emitEvent($event, option.event, option.data)">
                <span>{{option.value}}</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="legend" [hidden]="!row.legend?.length">
        <span *ngFor="let legend of row.legend; index as n;" [class]="'lib-legend ' + legend?.class || ''"
          [title]="legend?.value">{{legend?.value}}</span>
      </div>

      <lib-table *ngIf="!!row.subTable" [showHeaders]="!row.subTable?.hideHeaders" [data]="row.subTable"></lib-table>

    </li>
  </ul>
</div>